var React = require('react');

function UnencryptedIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.707 2.707a1 1 0 0 0-1.414-1.414L18.32 4.265 12 1.5 3 5.438c0 4.797 1.052 8.521 2.79 11.359l-4.497 4.496a1 1 0 1 0 1.414 1.414l20-20zM12 22.5a15.685 15.685 0 0 1-4.097-2.988L20.985 6.43C20.716 15.005 16.955 19.97 12 22.5z","fill":"#fff"}));
}

UnencryptedIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = UnencryptedIcon;

UnencryptedIcon.default = UnencryptedIcon;
